import { exportToCanvas } from "@excalidraw/utils/export";

import type { ExcalidrawElement } from "@excalidraw/element/types";
import type { AppState, BinaryFiles } from "@excalidraw/excalidraw/types";

const MAX_EDGE_PX = 400;
const JPEG_QUALITY = 0.7;

/**
 * Render the scene to an offscreen canvas and return a JPEG data URL suitable
 * for showing as a card thumbnail. Returns null when the scene has no visible
 * content (avoids saving blank previews).
 */
export async function generateThumbnail(
  elements: readonly ExcalidrawElement[],
  appState: Partial<AppState>,
  files: BinaryFiles | null,
): Promise<string | null> {
  const visible = (elements || []).filter((el) => !el.isDeleted);
  if (visible.length === 0) {
    return null;
  }

  try {
    const canvas = await exportToCanvas({
      elements: visible,
      appState: {
        ...appState,
        exportBackground: true,
        exportWithDarkMode: false,
        exportScale: 1,
      },
      files: files || {},
      maxWidthOrHeight: MAX_EDGE_PX,
    });

    return canvas.toDataURL("image/jpeg", JPEG_QUALITY);
  } catch (err) {
    console.warn("[thumbnail] failed to render scene:", err);
    return null;
  }
}
